<div class="breadcrumb_container" *ngIf="expandBreadcrumb">
  <span class="breadcrumb_home_icon"><button mat-icon-button matTooltip="Zeige Breadcrumb">
    <mat-icon routerLink="/vorhersagen/computer-mos/uebersicht">home</mat-icon></button></span>
  <span class="breadcrumb_right_arrow" style="color: #888888" *ngFor="let crumb of router.url.split('/')">
    <span class="breadcrumb_text" routerLink="{{crumb}}">{{crumb}}</span>
    <mat-icon>chevron_right</mat-icon></span>

</div>
